import {Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography} from '@material-ui/core';
import 'Agent/AgentInformation/components/RateGenerators.sass';
import {matchAsync} from 'Core/models/Async';
import * as NEA from 'fp-ts/lib/NonEmptyArray';
import * as O from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {ReactNode, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import ErrorPage from 'Shared/components/ErrorPage';
import FileDownloadButton from 'Shared/components/FileDownloadButton';
import Loading from 'Shared/components/Loading';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import {getRateGenerators} from '../ducks/rateGenerator';
import { updatefeatureVariables } from 'Core/ducks/featureToggle';

type RateGeneratorsProps = {selectedAgency: AgencyFilters};
const RateGenerators = ({selectedAgency}: RateGeneratorsProps) => {
  const dispatch = useDispatch();
  const {rateGenerators} = useSelector((state: ReducerState) => state.rateGenerators);
  const {featureVariables} = useSelector((state: ReducerState) => state.featureToggle);

  useEffect(() => {
    dispatch(getRateGenerators(selectedAgency.encryptedIdentifier));
  }, [selectedAgency]);

  useEffect(() => {
    dispatch(updatefeatureVariables({...featureVariables, FOOTER_OPEN_DEFAULT : false}));
  }, [])

  return (
    <div className="rate-generators">
      <Paper className="rate-generators__paper">
        <h1>Rate Generators</h1>
        <Typography>Please click on the link to view the most current rate generator. </Typography>
        {matchAsync(rateGenerators, {
          Loading: () => <Loading />,
          ServerError: error => <ErrorPage error={error} />,
          Unauthorized: error => <ErrorPage error={error} />,
          Conflict: error => <ErrorPage error={error} />,
          NoData: error => <ErrorPage error={error} />,
          NoContent: error => <ErrorPage error={error} />,
          Loaded: loadedRateGeneratorFileLinks =>
            // @ts-ignore
            pipe(
              loadedRateGeneratorFileLinks,
              NEA.fromArray,
              O.map(links => (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>File Name</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {links.map(({href, rel}) => (
                      <TableRow key={rel}>
                        <TableCell>{rel}</TableCell>
                        <TableCell>
                          <FileDownloadButton
                            downloadedFileName={rel}
                            displayTooltip={false}
                            relativeFileLocation={
                              href +
                              addFilterParameters({
                                encryptedIdentifier: selectedAgency.encryptedIdentifier,
                              })
                            }
                          >
                            Download
                          </FileDownloadButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )),
              O.getOrElse(
                (): ReactNode => <div className="rate-generators__no-results-message">No Results Available</div>
              )
            ),
        })}
      </Paper>
    </div>
  );
};

export default RateGenerators;
